import {
  get,
  post,
  postForm,
  del,
  put,
  patch
} from './request'

const HOST = BASEURL

// 获取验证码
export const getCaptcha = data => post(HOST + '/web/login/sendRegVerifyCode', data)
// export const getCaptcha = data => console.log(data)

// 注册
export const adminRegister = data => post(HOST + '/web/login/register', data)
//登录
export const adminLogin = data => post(HOST + '/web/login/login', data)

// 修改密码获取验证码
export const getModifyPasswordCaptcha = data =>
  post(HOST + '/web/Login/sendResetPasswordVerifyCode', data)

// 修改密码
export const modifyPassword = data => post(HOST + '/web/Login/resetPassword', data)

// 获取案例分类列表
export const getCaseClassificationList = data => post(HOST + '/web/index/cases_category', data)

// 获取案例列表详情
export const getCaseList = data => post(HOST + '/web/index/cases', data)

// 获取职位招聘信息
export const getJobList = data => post(HOST + '/web/index/recruit', data)

// 会员订阅
export const VipSubscribe = data => post(HOST + '/web/index/buy', data)

// 获取视频教程
export const getVideoList = data => post(HOST + '/web/index/course', data)

// 联系我们/留言
export const getContactUs = data => post(HOST + '/web/index/contact', data)

// 获取一个月免费会员
export const getFreeVip = data => post(HOST + '/web/Index/review', data)

// 获取英文邮件注册验证码
export const getEnglishCaptcha = data => post(HOST + '/web/Login/sendRegVerifyCodeByEmail', data)

// 获取重置密码验证码
export const getResetPasswordCaptcha = data =>
  post(HOST + '/web/Login/sendResetPasswordVerifyCodeByEmail', data)

// 根据用户id获取用户数据
// export const getAdminUserInfo = data => postForm(HOST + '/home/Personal/userinfo', data)

// 英文会员订阅
export const paypal = data => post(HOST + '/web/pay/paypal', data)

// 个人中心会员日期
export const getPaySuccess = data => post(HOST + '/web/index/paySuccess', data)


